import { MerchantId, SetHeaderService } from "@/helper/authenticationHelper";
import { DocumentTemplateHeaderTypeModel, DocumentWithPassCodeModel } from "@/model/document/documentModel";
import service from "../../baseHttpService";
import {
  PrepareDocumentInputData,
  PrepareDocumentPublicLinkInputData,
  PrepareUpdateDetailDocumentInputData,
} from "../documentFacade";

class InvoiceService {
  DoGetInvoiceDocumentPublicLink(input: DocumentWithPassCodeModel) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareDocumentPublicLinkInputData(input),
    };
    return service.peakOnlineView
      .post("/api/Invoice/GetInvoiceDocumentPublicLink", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetInvoiceDocument(input: DocumentTemplateHeaderTypeModel) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareDocumentInputData(input),
    };
    return service.peakOnlineView.post("/api/Invoice/GetInvoiceDocument", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoUpdateInvoiceDetailDocument(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareUpdateDetailDocumentInputData(input),
    };
    return service.peakOnlineView
      .post("/api/Invoice/UpdateInvoiceDetailDocument", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
}

export default new InvoiceService();
